import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../api";
import "./DepartmentList.css";
import DynamicBanner from "../../Pages/include/DynamicBanner";

const DepartmentListPage = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get("/api/general-hospital/departments");
                setCategories(response.data);
                setError(null);
            } catch (err) {
                console.error("Error fetching department list:", err);
                setError("Failed to load department categories.");
            } finally {
                setLoading(false);
            }
        };
        fetchDepartments();
    }, []);

    const departmentCategories = categories.categories;
    const departmentBanner = categories.banner_data;

    if (loading || error || departmentCategories.length === 0) return null;

    return (
        <>
        <DynamicBanner title={departmentBanner.title} bgImage={departmentBanner.desktop_images} bgImageMobile={departmentBanner.mobile_images} />
        <section className="departments-list-page pt_80 pb_80">
            <div className="container">
                <h2 className="sec-title text-center mb-5">Departments</h2>
                
                {departmentCategories.map((category) => (
                    <React.Fragment key={category.id}>
                        <div className="category-header mb-4">
                            <h3 className="department-category-title p-3 text-white">
                                {category.name}
                            </h3>
                            {(category.consultation_time || category.contact_details) && (
                                <p className="consult-info mt-2">
                                    Consultation Time: {category.consultation_time || 'N/A'} | Contact details: {category.contact_details || 'N/A'}
                                </p>
                            )}
                        </div>

                        <div className="row mb-5">
                            {category.departments.map((department) => (
                                <div key={department.id} className="col-md-4 col-sm-6 mb-3">
                                    <div className="department-link-wrapper">
                                        <i className="fa fa-circle me-2 text-primary"></i>
                                        <Link to={`/department/${department.slug}`}>
                                            {department.name}
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </section>
        </>
    );
};

export default DepartmentListPage;